// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"412":"ed877ca0","739":"4df76303"}[chunkId] + ".chunk.js";
};